import styled from 'styled-components'

export const Container = styled.div`
  height: ${p => p.height};
  overflow: hidden;
  color: #7f7f7f;
  padding-left: 4px;
  margin-left: auto;
  margin-right: -15px;
  transition: all .3s ease;
  max-width: 320px;

  @media (min-width: 768px) {
    border-top: solid 1px ${p => p.borderColor};
  }
`
export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  opacity: ${p => p.opacity};
  transition: all .3s ease;
  color: #1D3739;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }

  svg {
    margin-top: 4px;
  }

  @media (max-width: 767px) {
    svg {
      display: none;
    }
  }
`
export const Title = styled.h1`
  font-size: 25px;
  font-weight: 500;
  letter-spacing: 2px;
  margin: 0;
  margin-left: 0;
  font-family: 'Amorim Sans Serif';

  @media (min-width: 768px) {
    margin-left: 24px;
  }
`

export const InfoContainer = styled.div`
  height: 140px;
  margin-left: 0;
  opacity: ${p => p.isOpen? 1: 0 };
  transition: all .3s ease-out;

  @media (min-width: 768px) {
    margin-left: 44px;
  }
`

export const Paragraph = styled.p`
  font-size: 15px;
  margin-bottom: 0;
  letter-spacing: .6px;
`

export const PhoneAddressContainer = styled.div`
  height: 38px;
  display: flex;
  align-items: center;

  &.address-phone {
    margin-top: 15px;
  }

  svg {
    margin-right: 16px;
  }
`

export const Link = styled.a`
  display: block;
  color: #2D5A64;
  text-decoration: underline;
  transition: all .3s linear;
  font-size: 14px;
  letter-spacing: 1px;
  margin-top: 10px;
  margin-left: 40px;

  &:hover {
    color: #2D5A64;
    opacity: .8;
  }

  
`